import { ButtonGroup, Button } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { ThemePalette } from 'mui.theme';
import { memo } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import {
  type QuickRangeType,
  setActiveButton,
} from 'store/sensorAnalysis.slice';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';
import { useTranslation } from 'react-i18next';

const _palette = clientThemePalette[CLIENT_THEME];

const regularButtonGroupList: QuickRangeType[] = [
  'Today',
  '1D',
  '7D',
  '14D',
  '1Y',
  'All',
  'Custom',
];

const RANGE_LABEL_KEYS: Record<string, string> = {
  Today: 'date_range_today',
  '1D': 'date_range_1d',
  '7D': 'date_range_7d',
  '14D': 'date_range_14d',
  '1Y': 'date_range_1y',
  All: 'all',
  Custom: 'date_range_custom',
};

export const NewRangeFilter = memo(() => {
  const { t } = useTranslation();
  const { enableDarkTheme } = useAppTheme();
  const btnList = regularButtonGroupList;
  const activeButton = useAppSelector(
    (state) => state.sensorAnalysisReducer.regularFilters.activeButton
  );
  const dispatch = useAppDispatch();

  const handleSetActiveButton = (button: QuickRangeType) => {
    dispatch(setActiveButton(button));
  };

  return (
    <ButtonGroup
      size="small"
      aria-label={t('quick_range_filter')}
      sx={{
        border: `1px solid ${
          enableDarkTheme ? _palette.dark.borderGrey : _palette.light.borderGrey
        }`,
      }}
    >
      {btnList.map((item, index) => {
        return (
          <Button
            key={index}
            sx={{
              backgroundColor:
                activeButton === item
                  ? enableDarkTheme
                    ? _palette.dark.primary
                    : _palette.light.primary
                  : enableDarkTheme
                  ? _palette.dark.boxBackground
                  : (enableDarkTheme ? _palette.dark : _palette.light)
                      .boxBackground,
              color:
                activeButton === item
                  ? '#fff'
                  : (enableDarkTheme ? _palette.dark : _palette.light)
                      .textPrimary,
              textTransform: 'none',
            }}
            onClick={() => {
              handleSetActiveButton(item);
            }}
          >
            {t(RANGE_LABEL_KEYS[item] ?? item)}
          </Button>
        );
      })}
    </ButtonGroup>
  );
});

NewRangeFilter.displayName = 'NewRangeFilter';
